module.exports = __webpack_public_path__ + "img/20190523200049微信截图_20190523200425.4f2835f2.png";